import { TERMINOLOGY } from '@shared/i18n/terminology';
import { Body1Strong, Button, Divider } from '@fluentui/react-components';
import { EditRegular } from '@fluentui/react-icons';
import AvatarGroup from '@modules/users/components/AvatarGroup';
import { DateLabel } from '@shared/components/dates/DateLabel';
import ExpandableDescription from '@shared/components/ExpandableDescription';
import type { TProject, EProjectStatus } from '../types';
import ProjectStatusMenu from './ProjectStatusMenu';

const ProjectDetailsOverview = ({
  project,
  onEdit,
  canEdit,
  isPending,
  onStatusChange,
}: {
  project: TProject;
  onEdit: () => void;
  canEdit: boolean;
  isPending: boolean;
  onStatusChange: (status: EProjectStatus) => void;
}) => {
  return (
    <div className="flex-col pt-2 space-y-6">
      <div className="flex justify-center gap-2">
        <Button appearance="primary" icon={<EditRegular />} disabled={!canEdit || isPending} onClick={onEdit}>
          Edit details
        </Button>
        <ProjectStatusMenu status={project.status} onStatusChange={onStatusChange} disabled={!canEdit || isPending} />
      </div>

      <div className="space-y-5 px-5">
        <div className="flex">
          <span className="block w-32 flex-shrink-0">Start date</span>
          <Body1Strong>
            {project.startDate ? <DateLabel timeZone="UTC">{project.startDate}</DateLabel> : '-'}
          </Body1Strong>
        </div>
        <div className="flex">
          <span className="block w-32 flex-shrink-0">Due date</span>
          <Body1Strong>{project.dueDate ? <DateLabel timeZone="UTC">{project.dueDate}</DateLabel> : '-'}</Body1Strong>
        </div>
        <div className="flex items-center">
          <span className="block w-32 flex-shrink-0">{TERMINOLOGY.project.upper} leads</span>
          <AvatarGroup ids={project.leads} />
        </div>
        <div className="flex items-center">
          <span className="block w-32 flex-shrink-0">{TERMINOLOGY.project.upper} members</span>
          {project.members.length ? <AvatarGroup ids={project.members} /> : <Body1Strong>-</Body1Strong>}
        </div>

        <Divider className="py-3" />

        <div className="flex flex-col gap-2 pb-4">
          <Body1Strong>Description</Body1Strong>
          <ExpandableDescription description={project.description} />
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsOverview;
